// extracted by mini-css-extract-plugin
export default {"container":"createReceipt_container__5y9aq","title":"createReceipt_title__HW7WH","subtitle":"createReceipt_subtitle__B5Qd3","buttons":"createReceipt_buttons__kLOkI"};